import React, { useState } from "react";
import {
  Container,
  Box,
  Typography,
  Grid,
  Divider,
  Link,
  TextField,
} from "@mui/material";
import photoGridIcon from "../assets/svgs/plp-photo-grid-icon.svg";
import Button from "../components/common/Button/Button";
import ShareIcon from "@mui/icons-material/Share";
import FavoriteBorderIcon from "@mui/icons-material/FavoriteBorder";
import Machine1 from "../assets/images/machine1.png";
import Machine2 from "../assets/images/machine2.png";
import Machine3 from "../assets/images/machine3.png";
import Machine4 from "../assets/images/machine4.png";
import IosShareIcon from "@mui/icons-material/IosShare";
import Machine5 from "../assets/images/machine5.png";
import MachineMob from "../assets/images/machinemob.png";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import DoneIcon from "@mui/icons-material/Done";
import BottomShareModal from "../components/common/Modal/BottomShareModal";
import Map from "../assets/images/map.png";
import ListingShareModal from "../components/common/Modal/ListingShareModal";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import pro from "../assets/svgs/pro_icon_yellow.svg";
import LocationIcon from "../assets/svgs/location.svg";
import Field from "../components/common/Field/Fi";
import CheckIcon from "@mui/icons-material/Check";
import Equippo from "../assets/images/equipo.png";
import ContactSellerModal from "../components/common/Modal/ContactSellerModal";
import RequestCompletedModal from "../components/common/Modal/RequestCompletedModal";
import NumberVerifyModal from "../components/common/Modal/NumberVerifyModal";
import SimilarListingCard from "../components/common/SimilarListingCard/SimilarListingCard";
import Swipe from "../components/common/GalleryComponent/Swipe";
import useMediaQuery from "@mui/material/useMediaQuery";
import BottomOfferModal from "../components/common/Modal/BottomOfferModal";
import BottomContactSellerModal from "../components/common/Modal/BottomContactSellerModal";
import LoginModalPLP from "../components/common/Modal/LoginModalPLP";
import AllImageViewModal from "../components/common/Modal/AllImageViewModal";

import BreadCrumbs from "../components/common/BreadCrumbs/BreadCrumbs";
import Slider from "react-slick";

function nonProCard({
  handleContactSellerModal,
  handleRequestVerifiedModal,
  handleNumberVerify,
  handleAuthModal,
}) {
  return (
    <Box
      sx={{
        minWidth: "400px",
        boxShadow:
          "0px 8px 10px rgba(0, 0, 0, 0.14), 0px 3px 14px rgba(0, 0, 0, 0.12), 0px 5px 5px rgba(0, 0, 0, 0.2);",
        padding: "24px",
        height: "fit-content",
      }}
    >
      <Box sx={{ display: "flex", flexFlow: "column", alignItems: "center" }}>
        <img src={Equippo} width="90px" height="96px" alt="equippo" />
        <Link underline="none">
          <Typography
            variant="subtitle2"
            sx={{
              fontSize: "14px",
              fontWeight: "600",
              lineHeight: "20px",
              marginY: "24px",
            }}
          >
            View Seller
          </Typography>
        </Link>
      </Box>
      <Divider color="#D6D6D6" />
      <Box
        sx={{
          marginY: "24px",
          display: "flex",
          flexFlow: "column",
          rowGap: "2px",
        }}
      >
        <Typography
          variant="subtitle1"
          sx={{
            fontSize: "16px",
            fontWeight: "600",
            lineHeight: "24px",
          }}
        >
          Price by seller
        </Typography>
        <Typography
          variant="h3"
          sx={{
            fontSize: "22px",
            fontWeight: "600",
            lineHeight: "26px",
          }}
        >
          USD 800,000
        </Typography>
        <Typography
          variant="caption"
          sx={{
            fontSize: "12px",
            fontWeight: "400",
            lineHeight: "16px",
            color: "#616161",
          }}
        >
          Excluding taxes, shipping and other logistics.
        </Typography>
      </Box>
      <Divider color="#D6D6D6" />
      <Box sx={{ marginY: "24px" }}>
        <Typography
          variant="subtitle1"
          sx={{
            fontSize: "16px",
            fontWeight: "600",
            lineHeight: "24px",
            marginBottom: "8px",
          }}
        >
          Send your message to the seller
        </Typography>
        <TextField
          multiline
          sx={{
            width: "100%",
            "& .MuiOutlinedInput-input": {
              color: "#616161",
              minHeight: "198px",
            },
          }}
        />
      </Box>
      <Button
        variant="standard"
        bgColor="#F9D548"
        txColor="text.primary"
        typoSize="16px"
        fontWeight="600"
        typoVariant="subtitle1"
        hoverBg="#F3C04F"
        sx={{ lineHeight: "24px", width: "100%", height: "48px" }}
        onClick={() => {
          handleContactSellerModal(true);
          // handleRequestVerifiedModal(true);
          // handleNumberVerify(true);
          // handleAuthModal(true);
        }}
      >
        Contact seller
      </Button>
    </Box>
  );
}

function populateCard({ handleAuthModal }) {
  return (
    <Box
      sx={{
        minWidth: "400px",
        boxShadow:
          "0px 8px 10px rgba(0, 0, 0, 0.14), 0px 3px 14px rgba(0, 0, 0, 0.12), 0px 5px 5px rgba(0, 0, 0, 0.2);",
        padding: "24px",
        height: "fit-content",
      }}
    >
      <Box sx={{ marginBottom: "24px" }}>
        <Box sx={{ display: "flex", justifyContent: "space-between" }}>
          <Box>
            <Typography
              variant="subtitle1"
              sx={{
                fontSize: "16px",
                lineHeight: "24px",
                fontWeight: "600",
                marginBottom: "2px",
              }}
            >
              Price offered by seller
            </Typography>
            <Typography
              variant="h3"
              sx={{ fontSize: "22px", lineHeight: "26px", fontWeight: "600" }}
            >
              USD 800,000
            </Typography>
          </Box>
          <Button
            variant="contained"
            size="sm"
            bgColor="text.primary"
            txColor="#FFF"
            sx={{
              minWidth: "67px",
              height: "32px",
              boxShadow: "0",
              padding: "4px 8px 4px 10px",
              lineHeight: "24px",
              marginTop: "2px",
            }}
            typoVariant="subtitle1"
            typoSize="16px"
            fontWeight="600"
            startIcon={
              <img style={{ width: "14px", height: "14px" }} src={pro} />
            }
          >
            Pro
          </Button>
        </Box>
        <Typography
          variant="caption"
          sx={{
            fontSize: "12px",
            lineHeight: "16px",
            fontWeight: "400",
            color: "#616161",
          }}
        >
          Excluding taxes, shipping and other logistics.
        </Typography>
      </Box>
      <Box sx={{ marginBottom: "24px" }}>
        <Typography
          variant="caption"
          sx={{
            fontSize: "12px",
            lineHeight: "16px",
            fontWeight: "400",
            color: "#616161",
          }}
        >
          Please submit your offer in
          <span style={{ fontWeight: "700", color: "#1f1f1f" }}>USD</span>
        </Typography>
        <Field
          value="800,000"
          size="small"
          label=""
          height="46px"
          inputStyle={{
            fontSize: "16px",
            lineHeight: "24px",
            fontWeight: "600",
          }}
          sx={{
            backgroundColor: "#fff !important",
            marginBottom: "24px",
            width: "100%",
          }}
        />
        <Button
          bgColor="#F9D548"
          hoverBg="#F3C04F"
          txColor="text.primary"
          typoSize="16px"
          typoVariant="subtitle1"
          fontWeight="600"
          sx={{ width: "100%", lineHeight: "24px", height: "48px" }}
          onClick={() => {
            handleAuthModal(true);
          }}
        >
          Make an offer
        </Button>
      </Box>
      <Divider color="#D6D6D6" sx={{ marginBottom: "24px" }} />
      <Box sx={{ marginBottom: "16px" }}>
        <Typography
          variant="subtitle2"
          sx={{
            fontSize: "14px",
            lineHeight: "20px",
            fontWeight: "600",
            color: "#1f1f1f",
            marginBottom: "2px",
            display: "flex",
            alignItems: "center",
          }}
        >
          {
            <DoneIcon
              sx={{
                color: "text.primary",
                width: "13px",
                height: "13px",
                fontWeight: "bold",
                marginRight: "3px",
              }}
            />
          }
          Inspected Machine
        </Typography>
        <Typography
          variant="body2"
          sx={{
            fontSize: "14px",
            lineHeight: "20px",
            fontWeight: "400",
            color: "#616161",
            paddingLeft: "16px",
          }}
        >
          We don’t love surprises either
        </Typography>
      </Box>
      <Box sx={{ marginBottom: "16px" }}>
        <Typography
          variant="subtitle2"
          sx={{
            fontSize: "14px",
            lineHeight: "20px",
            fontWeight: "600",
            color: "#1f1f1f",
            marginBottom: "2px",
            display: "flex",
            alignItems: "center",
          }}
        >
          {
            <DoneIcon
              sx={{
                color: "text.primary",
                width: "13px",
                height: "13px",
                fontWeight: "bold",
                marginRight: "3px",
              }}
            />
          }{" "}
          Secure Payment
        </Typography>
        <Typography
          variant="body2"
          sx={{
            fontSize: "14px",
            lineHeight: "20px",
            fontWeight: "400",
            color: "#616161",
            paddingLeft: "16px",
          }}
        >
          Pay through Escrow.com
        </Typography>
      </Box>
      <Box>
        <Typography
          variant="subtitle2"
          sx={{
            fontSize: "14px",
            lineHeight: "20px",
            fontWeight: "600",
            color: "#1f1f1f",
            display: "flex",
            alignItems: "center",
            marginBottom: "2px",
          }}
        >
          {
            <DoneIcon
              sx={{
                color: "text.primary",
                width: "13px",
                height: "13px",
                fontWeight: "bold",
                marginRight: "3px",
              }}
            />
          }{" "}
          Money-back Guarantee
        </Typography>
        <Typography
          variant="body2"
          sx={{
            fontSize: "14px",
            lineHeight: "20px",
            fontWeight: "400",
            color: "#616161",
            paddingLeft: "16px",
          }}
        >
          Not as advertised? 100% refund
        </Typography>
      </Box>
    </Box>
  );
}

function ProductPage({ match }) {
  const NextArrow = ({ onClick }) => {
    return (
      <Swipe
        direction="right"
        arrowColor="#1f1f1f"
        // swipeStyle={{ marginRight: "24px" }}
        onClick={onClick}
      />
    );
  };

  const PrevArrow = ({ onClick }) => {
    return (
      <Swipe
        arrowColor="#1f1f1f"
        swipeStyle={{ marginRight: "24px" }}
        onClick={onClick}
      />
    );
  };

  const settings = {
    speed: 500,
    slidesToShow: 4,
  };
  const [loggedIn, setloggedIn] = useState(
    match.params.login === "true" ? true : false
  );

  const tabMatch = useMediaQuery("(max-width:900px)");
  const mobMatch = useMediaQuery("(max-width:600px)");
  const [showShareModal, setShowShareModal] = useState(false);
  const [showBottomShareModal, setShowBottomShareModal] = useState(false);
  const toggleDrawerShare = (bool) => {
    setShowBottomShareModal(bool);
  };
  const [contactSellerModalOpen, setContactSellerModalOpen] = useState(false);
  function handleContactSellerModal(bool) {
    setContactSellerModalOpen(bool);
  }
  const [RequestVerifiedModal, setRequestVerifiedModal] = useState(false);
  function handleRequestVerifiedModal(bool) {
    setRequestVerifiedModal(bool);
  }
  const [numberVerify, setNumberVerify] = useState(false);
  function handleNumberVerify(bool) {
    setNumberVerify(bool);
  }

  const [bottomOffer, setBottomOffer] = useState(false);
  function handleBottomOffer(bool) {
    setBottomOffer(bool);
  }

  const [bottomContactSeller, setBottomContactSeller] = useState(false);
  function handleBottomContactSeller(bool) {
    setBottomContactSeller(bool);
  }

  const [authModal, setAuthModal] = useState(false);
  function handleAuthModal(bool) {
    setAuthModal(bool);
  }

  const [openAllImageView, setOpenAllImageView] = useState(false);
  const handleAllImageView = (bool) => {
    setOpenAllImageView(bool);
  };

  return (
    <Container sx={{ background: "#fff" }} disableGutters={mobMatch}>
      {!mobMatch && (
        <BreadCrumbs
          sx={{ marginTop: "32px" }}
          breadCrumbList={[
            "Pro Machinery for Sale",
            "Excavator",
            "Wheel Excavator",
            "Caterpillar",
            "988f",
          ]}
        />
      )}
      {mobMatch && (
        <Box>
          <Box sx={{ position: "relative" }}>
            <img
              onClick={() => {
                handleAllImageView(true);
              }}
              src={MachineMob}
              style={{ width: "100%", height: "250px", objectFit: "" }}
              alt="machine"
            />
            <Box
              sx={{
                width: "100%",
                position: "absolute",
                top: "0",
                display: "flex",
                justifyContent: "space-between",
              }}
            >
              <Box
                sx={{
                  background: "#fff",
                  width: "32px",
                  height: "32px",
                  borderRadius: "50px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  margin: "20px 16px",
                }}
              >
                <ArrowBackIcon
                  sx={{ width: "24px", height: "24px", color: "#255CCE" }}
                />
              </Box>
              <Box sx={{ display: "flex", flexFlow: "row" }}>
                <Box
                  sx={{
                    background: "#fff",
                    width: "32px",
                    height: "32px",
                    borderRadius: "50px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    margin: "20px 16px",
                  }}
                >
                  <IosShareIcon
                    onClick={() => {
                      toggleDrawerShare(true);
                    }}
                    sx={{ width: "24px", height: "24px", color: "#255CCE" }}
                  />
                </Box>
                <Box
                  sx={{
                    background: "#fff",
                    width: "32px",
                    height: "32px",
                    borderRadius: "50px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    margin: "20px 16px",
                  }}
                >
                  <FavoriteBorderIcon
                    sx={{ width: "24px", height: "24px", color: "#255CCE" }}
                  />
                </Box>
              </Box>
            </Box>
          </Box>
        </Box>
      )}
      <Box
        sx={{
          marginY: { sm: "32px" },
          display: "flex",
          justifyContent: "space-between",
          alignItems: "flex-end",
        }}
      >
        <Box
          sx={{ width: { sm: "66%" }, margin: { xs: "24px 16px", sm: "0" } }}
        >
          <Typography
            variant={mobMatch ? "h3" : "h2"}
            sx={{
              fontSize: { xs: "22px", sm: "32px" },
              lineHeight: { xs: "26px", sm: "36px" },
              fontWeight: { xs: "600", sm: "700" },
              wordWrap: "break-word",
            }}
          >
            Caterpillar 988f wheel loaders/ integrated tools carriers 70
            Characters
          </Typography>
          <Typography
            sx={{
              color: "#616161",
              fontSize: { xs: "12px", sm: "14px" },
              lineHeight: { xs: "16px", sm: "20px" },
              marginTop: { xs: "8px", sm: "0px" },
            }}
            variant={mobMatch ? "caption" : "body2"}
          >
            Reference: CAT-CRA-100278 | Stock: 1,545
          </Typography>
        </Box>
        {!mobMatch && (
          <Box>
            <Button
              hoverBg="primary.main"
              hoverTxColor="white"
              variant="outlined"
              outColor="#255CCE"
              sx={{
                height: "36px",
                width: "88px",
                lineHeight: "20px",
                marginRight: "16px",
              }}
              startIcon={
                <IosShareIcon
                  sx={{ width: "12px", height: "12px", color: "#255CCE" }}
                />
              }
              typoVariant="subtitle2"
              txColor="#255CCE"
              typoSize="14px"
              fontWeight="600"
              onClick={() => {
                setShowShareModal(true);
              }}
            >
              Share
            </Button>
            <Button
              hoverBg="primary.main"
              hoverTxColor="white"
              variant="outlined"
              outColor="#255CCE"
              sx={{
                height: "36px",
                width: "88px",
                lineHeight: "20px",
              }}
              startIcon={
                <FavoriteBorderIcon
                  sx={{
                    width: "12px",
                    height: "12px",
                    color: "#255CCE",
                  }}
                />
              }
              typoVariant="subtitle2"
              txColor="#255CCE"
              typoSize="14px"
              fontWeight="600"
            >
              Save
            </Button>
          </Box>
        )}
      </Box>

      {mobMatch && <Divider sx={{ marginX: "16px" }} color="#D6D6D6" />}

      {!mobMatch && (
        <Container
          sx={{ display: "flex", columnGap: "8px", position: "relative" }}
          disableGutters={true}
        >
          <Box
            sx={{
              position: "absolute",
              right: "-20px",
              bottom: "0%",
              margin: "24px",
            }}
          >
            <Button
              bgColor="#fff"
              variant="body2"
              typoSize="14px"
              hoverBg="#fff"
              sx={{
                width: "153px",
                height: "36px",
                lineHeight: "20px",
                border: "1px solid #1f1f1f",
                boxShadow:
                  "0px 1px 1px rgba(0, 0, 0, 0.14), 0px 2px 1px rgba(0, 0, 0, 0.12), 0px 1px 3px rgba(0, 0, 0, 0.2)",
                padding: "0px",
              }}
              onClick={() => {
                handleAllImageView(true);
              }}
            >
              <img
                src={photoGridIcon}
                style={{
                  width: "12px",
                  height: "12px",
                  marginRight: "4px",
                }}
                alt="showmore"
              />
              Show all photos
            </Button>
          </Box>
          <Box sx={{ width: "50%" }}>
            <img
              src={Machine1}
              style={{
                width: "100%",
                maxWidth: "600px",
                maxHeight: "400px",
                height: "100%",
              }}
              alt="video"
            />
          </Box>
          <Box
            sx={{
              width: "50%",
              display: "flex",
              flexFlow: "column",
              rowGap: "8px",
            }}
          >
            <Box sx={{ display: "flex", columnGap: "8px" }}>
              <img
                src={Machine2}
                style={{
                  width: "100%",
                  maxWidth: "292px",
                  maxHeight: "196px",
                  height: "100%",
                }}
                alt="machine"
              />
              <img
                src={Machine4}
                style={{
                  width: "100%",
                  maxWidth: "292px",
                  maxHeight: "196px",
                  height: "100%",
                }}
                alt="machine"
              />
            </Box>
            <Box sx={{ display: "flex", columnGap: "8px" }}>
              <img
                src={Machine3}
                alt="machine"
                style={{
                  width: "100%",
                  maxWidth: "292px",
                  maxHeight: "196px",
                  height: "100%",
                }}
              />
              <img
                src={Machine5}
                alt="machine"
                style={{
                  width: "100%",
                  maxWidth: "292px",
                  maxHeight: "196px",
                  height: "100%",
                }}
              />
            </Box>
          </Box>
        </Container>
      )}
      {/*  */}
      <Container
        sx={{
          marginTop: { xs: "24px", sm: "48px" },
          display: "flex",
          columnGap: "152px",
          justifyContent: "space-between",
        }}
        disableGutters={true}
      >
        <Box sx={{ width: { sm: "54%" }, marginX: { xs: "16px", sm: "0px" } }}>
          {!mobMatch && (
            <Typography
              variant="h3"
              sx={{
                fontSize: "22px",
                lineHeight: "26px",
                fontWeight: "600",
                color: "text.primary",
                marginBottom: "24px",
              }}
            >
              Wheel Excavator, Caterpillar, 988f
            </Typography>
          )}
          <Grid container rowGap="16px" xs={12}>
            <Grid item xs={6} sm={4}>
              <Typography
                variant="body1"
                sx={{
                  fontSize: "16px",
                  lineHeight: "24px",
                  fontWeight: "400",
                  color: "text.primary",
                }}
              >
                Year
              </Typography>
              <Typography
                variant="subtitle1"
                sx={{
                  fontSize: "16px",
                  lineHeight: "24px",
                  fontWeight: "600",
                  color: "text.primary",
                }}
              >
                2,000
              </Typography>
            </Grid>
            <Grid item xs={6} sm={4}>
              <Typography
                variant="body1"
                sx={{
                  fontSize: "16px",
                  lineHeight: "24px",
                  fontWeight: "400",
                  color: "text.primary",
                }}
              >
                Hours
              </Typography>
              <Typography
                variant="subtitle1"
                sx={{
                  fontSize: "16px",
                  lineHeight: "24px",
                  fontWeight: "600",
                  color: "text.primary",
                }}
              >
                295,000
              </Typography>
            </Grid>
            <Grid item xs={5} sm={4}>
              <Typography
                variant="body1"
                sx={{
                  fontSize: "16px",
                  lineHeight: "24px",
                  fontWeight: "400",
                  color: "text.primary",
                }}
              >
                Condition
              </Typography>
              <Typography
                variant="subtitle1"
                sx={{
                  fontSize: "16px",
                  lineHeight: "24px",
                  fontWeight: "600",
                  color: "text.primary",
                }}
              >
                Used
              </Typography>
            </Grid>
          </Grid>
          {mobMatch && <Divider color="#D6D6D6" sx={{ marginTop: "35px" }} />}
          {mobMatch && (
            <Box sx={{ paddingY: "24px" }}>
              <Box sx={{ display: "flex", justifyContent: "space-between" }}>
                <Typography
                  variant="h3"
                  sx={{
                    fontSize: "22px",
                    lineHeight: "26px",
                    fontWeight: "600",
                    color: "text.primary",
                  }}
                >
                  Pro Machinery
                </Typography>
                <Button
                  variant="contained"
                  size="sm"
                  bgColor="text.primary"
                  txColor="#FFF"
                  sx={{
                    minWidth: "67px",
                    height: "32px",
                    boxShadow: "0",
                    padding: "4px 8px 4px 10px",
                    lineHeight: "24px",
                    marginTop: "2px",
                  }}
                  typoVariant="subtitle1"
                  typoSize="16px"
                  fontWeight="600"
                  startIcon={
                    <img style={{ width: "14px", height: "14px" }} src={pro} />
                  }
                >
                  Pro
                </Button>
              </Box>

              <Box sx={{ marginBottom: "16px" }}>
                <Typography
                  variant="subtitle2"
                  sx={{
                    fontSize: "14px",
                    lineHeight: "20px",
                    fontWeight: "600",
                    color: "#1f1f1f",
                    marginBottom: "2px",
                  }}
                >
                  ✓ Inspected Machine
                </Typography>
                <Typography
                  variant="body2"
                  sx={{
                    fontSize: "14px",
                    lineHeight: "20px",
                    fontWeight: "400",
                    color: "#616161",
                    paddingLeft: "16px",
                  }}
                >
                  We don’t love surprises either
                </Typography>
              </Box>
              <Box sx={{ marginBottom: "16px" }}>
                <Typography
                  variant="subtitle2"
                  sx={{
                    fontSize: "14px",
                    lineHeight: "20px",
                    fontWeight: "600",
                    color: "#1f1f1f",
                    marginBottom: "2px",
                  }}
                >
                  ✓ Secure Payment
                </Typography>
                <Typography
                  variant="body2"
                  sx={{
                    fontSize: "14px",
                    lineHeight: "20px",
                    fontWeight: "400",
                    color: "#616161",
                    paddingLeft: "16px",
                  }}
                >
                  Pay through Escrow.com
                </Typography>
              </Box>
              <Box>
                <Typography
                  variant="subtitle2"
                  sx={{
                    fontSize: "14px",
                    lineHeight: "20px",
                    fontWeight: "600",
                    color: "#1f1f1f",
                    marginBottom: "2px",
                  }}
                >
                  ✓ Money-back Guarantee
                </Typography>
                <Typography
                  variant="body2"
                  sx={{
                    fontSize: "14px",
                    lineHeight: "20px",
                    fontWeight: "400",
                    color: "#616161",
                    paddingLeft: "16px",
                  }}
                >
                  Not as advertised? 100% refund
                </Typography>
              </Box>
            </Box>
          )}
          {mobMatch && (
            <Divider
              color="#D6D6D6"
              sx={{
                marginBottom: { xs: "24px", sm: "48px" },
              }}
            />
          )}
          <Box
            sx={{
              width: "100%",
              marginTop: "24px",
              marginBottom: { sm: "48px" },
            }}
          >
            <Typography
              variant="body1"
              sx={{
                fontSize: "16px",
                lineHeight: "24px",
                fontWeight: "400",
                color: "#616161",
              }}
            >
              Description
            </Typography>
            <Typography
              variant="body1"
              sx={{
                fontSize: "16px",
                lineHeight: "24px",
                fontWeight: "400",
                color: "text.primary",
              }}
            >
              Are you looking for more equipment? We can help you find used
              tracked excavators, used mini excavators, used wheel loaders, used
              single drum rollers, used telescopic boom lifts, used articulated
              boom lifts, used scissor lifts used and 250 Characters.
            </Typography>
            <Typography
              variant="body1"
              sx={{
                fontSize: "16px",
                lineHeight: "24px",
                fontWeight: "400",
                color: "#255CCE",
              }}
            >
              Show More
            </Typography>
          </Box>
          <Divider
            color="#D6D6D6"
            sx={{
              marginBottom: { xs: "24px", sm: "48px" },
              marginTop: { xs: "24px", sm: "0px" },
            }}
          />
          <Box>
            <Typography
              variant="h3"
              sx={{
                marginBottom: "8px",
                fontSize: "22px",
                fontWeight: "600",
                lineHeight: "26px",
              }}
            >
              Location
            </Typography>
            <Typography
              variant="subtitle1"
              sx={{
                marginBottom: "24px",
                fontSize: "16px",
                fontWeight: "600",
                lineHeight: "24px",
                color: "#616161",
              }}
            >
              Equippo AG , Germany
            </Typography>
            <Box
              sx={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                marginBottom: { sm: "48px" },
                width: { xs: "100%", sm: "648px" },
                height: "150px",
                background: `url(${Map}) center center no-repeat`,
                backgroundSize: { xs: "cover", sm: "contain" },
                imageRendering: "-webkit-optimize-contrast",
                borderRadius: "8px",
              }}
            >
              <Button
                sx={{
                  width: "130px",
                  height: "36px",
                  borderRadius: "4px",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  paddingX: "auto",
                }}
                bgColor="#fff"
                typoVariant="subtitle"
                fontWeight="600"
                txColor="#255CCE"
                outColor="#255CCE"
                typoSize="14px"
                hoverBg="primary.main"
                hoverTxColor="white"
                variant="outlined"
              >
                View on Map
              </Button>
            </Box>
          </Box>
          {!mobMatch && <Divider color="#D6D6D6" sx={{ marginY: "48px" }} />}
          {mobMatch && <Divider color="#D6D6D6" sx={{ marginY: "24px" }} />}
          <Box sx={{ marginBottom: { xs: "24px", sm: "48px" } }}>
            <Typography
              variant="h3"
              sx={{
                marginBottom: "8px",
                fontSize: "22px",
                fontWeight: "600",
                lineHeight: "26px",
              }}
            >
              Inspection Report
            </Typography>
            <Typography
              variant="subtitle1"
              sx={{
                marginBottom: "24px",
                fontSize: "16px",
                fontWeight: "600",
                lineHeight: "24px",
                color: "#616161",
              }}
            >
              Get a condition report in minutes and buy with confidence.
            </Typography>
            <Button
              sx={{
                width: "152px",
                height: "36px",
                borderRadius: "4px",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                paddingX: "0px",
              }}
              startIcon={
                <CheckCircleOutlineIcon
                  sx={{ width: "12px", height: "12px", color: "#255CCE" }}
                />
              }
              bgColor="#fff"
              typoVariant="subtitle"
              fontWeight="600"
              txColor="#255CCE"
              outColor="#255CCE"
              typoSize="14px"
              hoverBg="primary.main"
              hoverTxColor="white"
              variant="outlined"
            >
              Request Report
            </Button>
          </Box>
          <Divider color="#D6D6D6" />
          <Box sx={{ marginTop: "48px", marginBottom: "48px" }}>
            <Typography
              variant="h3"
              sx={{
                marginBottom: "8px",
                fontSize: "22px",
                fontWeight: "600",
                lineHeight: "26px",
              }}
            >
              Other Information
            </Typography>
            <Box>
              <Grid container sx={{ width: { xs: "100%", sm: "424px" } }}>
                <Grid item xs={12}>
                  <Typography
                    variant="h3"
                    sx={{
                      color: "#616161",
                      marginBottom: "8px",
                      fontSize: "16px",
                      fontWeight: "600",
                      lineHeight: "24px",
                    }}
                  >
                    Capacity
                  </Typography>
                </Grid>
                <Grid item sx={{ display: "flex", columnGap: "24px" }} xs={12}>
                  <Grid item xs={6}>
                    <Typography
                      variant="h3"
                      sx={{
                        color: "#616161",
                        marginBottom: "8px",
                        fontSize: "16px",
                        fontWeight: "400",
                        lineHeight: "24px",
                      }}
                    >
                      Tower Capacity
                    </Typography>
                  </Grid>
                  <Grid item xs={6}>
                    <Typography
                      variant="h3"
                      sx={{
                        color: "#616161",
                        marginBottom: "8px",
                        fontSize: "16px",
                        fontWeight: "400",
                        lineHeight: "24px",
                      }}
                    >
                      36,200
                    </Typography>
                  </Grid>
                </Grid>
                <Grid item sx={{ display: "flex", columnGap: "24px" }} xs={12}>
                  <Grid item xs={6}>
                    <Typography
                      variant="h3"
                      sx={{
                        color: "#616161",
                        marginBottom: "8px",
                        fontSize: "16px",
                        fontWeight: "400",
                        lineHeight: "24px",
                      }}
                    >
                      Weight (KG)
                    </Typography>
                  </Grid>
                  <Grid item xs={6}>
                    <Typography
                      variant="h3"
                      sx={{
                        color: "#616161",
                        marginBottom: "8px",
                        fontSize: "16px",
                        fontWeight: "400",
                        lineHeight: "24px",
                      }}
                    >
                      17,150
                    </Typography>
                  </Grid>
                </Grid>
                {/*  */}
                <Grid item sx={{ marginTop: "24px" }} xs={12}>
                  <Typography
                    variant="h3"
                    sx={{
                      color: "#616161",
                      marginBottom: "8px",
                      fontSize: "16px",
                      fontWeight: "600",
                      lineHeight: "24px",
                    }}
                  >
                    Drive Train
                  </Typography>
                </Grid>
                <Grid item sx={{ display: "flex", columnGap: "24px" }} xs={12}>
                  <Grid item xs={6}>
                    <Typography
                      variant="h3"
                      sx={{
                        color: "#616161",
                        marginBottom: "8px",
                        fontSize: "16px",
                        fontWeight: "400",
                        lineHeight: "24px",
                      }}
                    >
                      Horsepower (HP)
                    </Typography>
                  </Grid>
                  <Grid item xs={6}>
                    <Typography
                      variant="h3"
                      sx={{
                        color: "#616161",
                        marginBottom: "8px",
                        fontSize: "16px",
                        fontWeight: "400",
                        lineHeight: "24px",
                      }}
                    >
                      425
                    </Typography>
                  </Grid>
                </Grid>
                {/*  */}
                <Grid
                  item
                  sx={{ marginTop: "24px", columnGap: "24px" }}
                  xs={12}
                >
                  <Typography
                    variant="h3"
                    sx={{
                      color: "#616161",
                      marginBottom: "8px",
                      fontSize: "16px",
                      fontWeight: "600",
                      lineHeight: "24px",
                    }}
                  >
                    Speed Capacity
                  </Typography>
                </Grid>
                <Grid item sx={{ display: "flex", columnGap: "24px" }} xs={12}>
                  <Grid item xs={6}>
                    <Typography
                      variant="h3"
                      sx={{
                        color: "#616161",
                        marginBottom: "8px",
                        fontSize: "16px",
                        fontWeight: "400",
                        lineHeight: "24px",
                      }}
                    >
                      Speed Max Travel
                    </Typography>
                  </Grid>
                  <Grid item xs={6}>
                    <Typography
                      variant="h3"
                      sx={{
                        color: "#616161",
                        marginBottom: "8px",
                        fontSize: "16px",
                        fontWeight: "400",
                        lineHeight: "24px",
                      }}
                    >
                      Max
                    </Typography>
                  </Grid>
                </Grid>
                <Grid item sx={{ display: "flex", columnGap: "24px" }} xs={12}>
                  <Grid item xs={6}>
                    <Typography
                      variant="h3"
                      sx={{
                        color: "#616161",
                        marginBottom: "8px",
                        fontSize: "16px",
                        fontWeight: "400",
                        lineHeight: "24px",
                      }}
                    >
                      Swing Torque (Ft.-Lbf.)
                    </Typography>
                  </Grid>
                  <Grid item xs={6}>
                    <Typography
                      variant="h3"
                      sx={{
                        color: "#616161",
                        marginBottom: "8px",
                        fontSize: "16px",
                        fontWeight: "400",
                        lineHeight: "24px",
                      }}
                    >
                      137,924
                    </Typography>
                  </Grid>
                </Grid>
                {/*  */}
                <Grid
                  item
                  sx={{ marginTop: "24px", columnGap: "24px" }}
                  xs={12}
                >
                  <Typography
                    variant="h3"
                    sx={{
                      color: "#616161",
                      marginBottom: "8px",
                      fontSize: "16px",
                      fontWeight: "600",
                      lineHeight: "24px",
                    }}
                  >
                    Dimensions
                  </Typography>
                </Grid>
                <Grid item sx={{ display: "flex", columnGap: "24px" }} xs={12}>
                  <Grid item xs={6}>
                    <Typography
                      variant="h3"
                      sx={{
                        color: "#616161",
                        marginBottom: "8px",
                        fontSize: "16px",
                        fontWeight: "400",
                        lineHeight: "24px",
                      }}
                    >
                      Machine Width
                    </Typography>
                  </Grid>
                  <Grid item xs={6}>
                    <Typography
                      variant="h3"
                      sx={{
                        color: "#616161",
                        marginBottom: "8px",
                        fontSize: "16px",
                        fontWeight: "400",
                        lineHeight: "24px",
                      }}
                    >
                      125
                    </Typography>
                  </Grid>
                </Grid>
                <Grid item sx={{ display: "flex", columnGap: "24px" }} xs={12}>
                  <Grid item xs={6}>
                    <Typography
                      variant="h3"
                      sx={{
                        color: "#616161",
                        marginBottom: "8px",
                        fontSize: "16px",
                        fontWeight: "400",
                        lineHeight: "24px",
                      }}
                    >
                      Machine Height
                    </Typography>
                  </Grid>
                  <Grid item xs={6}>
                    <Typography
                      variant="h3"
                      sx={{
                        color: "#616161",
                        marginBottom: "8px",
                        fontSize: "16px",
                        fontWeight: "400",
                        lineHeight: "24px",
                      }}
                    >
                      110
                    </Typography>
                  </Grid>
                </Grid>
                {/*  */}
                <Grid item sx={{ marginTop: "24px" }} xs={12}>
                  <Typography
                    variant="h3"
                    sx={{
                      color: "#616161",
                      marginBottom: "8px",
                      fontSize: "16px",
                      fontWeight: "600",
                      lineHeight: "24px",
                    }}
                  >
                    Drivetrain
                  </Typography>
                </Grid>
                <Grid item sx={{ display: "flex", columnGap: "24px" }} xs={12}>
                  <Grid item xs={6}>
                    <Typography
                      variant="h3"
                      sx={{
                        color: "#616161",
                        marginBottom: "8px",
                        fontSize: "16px",
                        fontWeight: "400",
                        lineHeight: "24px",
                      }}
                    >
                      Std Pump Flow (l/m)
                    </Typography>
                  </Grid>
                  <Grid item xs={6}>
                    <Typography
                      variant="h3"
                      sx={{
                        color: "#616161",
                        marginBottom: "8px",
                        fontSize: "16px",
                        fontWeight: "400",
                        lineHeight: "24px",
                      }}
                    >
                      300
                    </Typography>
                  </Grid>
                </Grid>
              </Grid>
            </Box>
          </Box>
        </Box>
        {/*  */}

        {!mobMatch &&
          loggedIn &&
          populateCard({
            handleContactSellerModal,
            handleRequestVerifiedModal,
            handleNumberVerify,
            handleAuthModal,
          })}
        {/* {populateCard()} */}
        {!mobMatch &&
          !loggedIn &&
          nonProCard({
            handleContactSellerModal,
            handleRequestVerifiedModal,
            handleNumberVerify,
            handleAuthModal,
          })}
      </Container>

      {loggedIn && <Divider color="#D6D6D6" sx={{}} />}
      {loggedIn && (
        <Container
          sx={{
            width: { md: "1200px" },
            marginX: { xs: "16px", sm: "0px" },
            marginTop: "48px",
            marginBottom: { xs: "16px", sm: "72px" },
            paddingBottom: { xs: "24px", sm: "0px" },
            borderRadius: { xs: "8px", sm: "0px" },
          }}
          disableGutters={true}
        >
          <Typography
            sx={{ fontWeight: "600", fontSize: "22px", lineHeight: "26px" }}
            variant="h3"
          >
            View similar listings
          </Typography>
          <Container
            sx={{
              display: "flex",
              marginTop: "24px",

              alignItems: "center",
            }}
            disableGutters={true}
          >
            {/* {!mobMatch && (
              <Swipe
                arrowColor="#BFBFBF"
                className="swiper-similarListings-prev"
                swipeStyle={{ marginRight: "24px" }}
              />
            )} */}
            <Box
              sx={{
                maxWidth: "1200px",
                "& .slick-slider": {
                  display: "flex",
                  alignItems: "center",
                  // justifyContent: "space-between",
                  // columnGap: "24px",
                  "& .slick-list": {
                    padding: "5px 0px",
                    width: "1112%",
                    marginRight: "24px",
                    "& .slick-track ": {
                      display: "flex",
                      columnGap: "16px",
                    },
                  },
                },
              }}
            >
              <Slider
                {...settings}
                nextArrow={<NextArrow />}
                prevArrow={<PrevArrow />}
                arrows={!mobMatch ? true : false}
              >
                <SimilarListingCard img={Machine1} />
                <SimilarListingCard img={Machine1} />
                <SimilarListingCard img={Machine1} />
                <SimilarListingCard img={Machine1} />
                <SimilarListingCard img={Machine1} />
                <SimilarListingCard img={Machine1} />
                <SimilarListingCard img={Machine1} />
                <SimilarListingCard img={Machine1} />
              </Slider>
              {/* <SimilarListingCard img={Machine1} />
              <SimilarListingCard img={Machine1} />
              <SimilarListingCard img={Machine1} />
              <SimilarListingCard img={Machine1} />
              <SimilarListingCard img={Machine1} /> */}
            </Box>
            {/* {!mobMatch && (
              <Swipe
                className="swiper-similarListings-next"
                swipeStyle={{ marginLeft: "24px" }}
                direction="right"
              />
            )} */}
          </Container>
        </Container>
      )}
      <BottomShareModal
        open={showBottomShareModal}
        toggleDrawer={toggleDrawerShare}
      />
      <ListingShareModal open={showShareModal} setOpen={setShowShareModal} />
      <AllImageViewModal open={openAllImageView} setOpen={handleAllImageView} />
      <ContactSellerModal
        open={contactSellerModalOpen}
        setOpen={setContactSellerModalOpen}
        verifiedModal={handleRequestVerifiedModal}
      />
      <LoginModalPLP
        open={authModal}
        setOpen={handleAuthModal}
        children={<ProductDetails />}
      />
      <RequestCompletedModal
        open={RequestVerifiedModal}
        setOpen={setRequestVerifiedModal}
        heading="Request Sent"
        desc="Thanks for getting in touch. Seller will get back to you soon."
      />
      <BottomContactSellerModal
        open={bottomContactSeller}
        toggleDrawer={handleBottomContactSeller}
      />
      <BottomOfferModal open={bottomOffer} toggleDrawer={handleBottomOffer} />
      <NumberVerifyModal open={numberVerify} setOpen={setNumberVerify} />
      {mobMatch && (
        <Box
          sx={{
            display: "flex",
            width: "100%",
            columnGap: "24px",
            padding: "16px",
            height: "80px",
            position: "absolute",
            // top: "0",
            backgroundColor: "white",
            justifyContent: "space-between",
            bottom: "0",
            boxShadow: "0px 0px 4px rgba(0, 0, 0, 0.8)",
            zIndex: "1 !important",
          }}
        >
          <Box sx={{ width: "149px" }}>
            <Typography
              variant="subtitle1"
              sx={{ fontSize: "16px", lineHeight: "24px", fontWeight: "600" }}
            >
              USD 800,000
            </Typography>
            <Typography
              sx={{ fontSize: "8px", lineHeight: "9.86px", color: "#616161" }}
            >
              Price offered by seller. Excluding taxes, shipping and other
              logistics.
            </Typography>
          </Box>
          <Button
            onClick={() => {
              loggedIn
                ? handleBottomOffer(true)
                : handleBottomContactSeller(true);
            }}
            typoVariant="subtitle1"
            typoSize="16px"
            txColor="text.primary"
            hoverBg="#F3C04F"
            bgColor="#F9D548"
            fontWeight="600"
            sx={{ height: "48px", width: "170px" }}
          >
            {loggedIn ? "Make an offer" : "Contact Seller"}
          </Button>
        </Box>
      )}
    </Container>
  );
}

const ProductDetails = () => {
  return (
    <Box sx={{ width: "336px", marginTop: "32px" }}>
      <img
        src={Machine1}
        alt="machine"
        style={{ borderRadius: "8px", width: "100%", height: "207px" }}
      />
      <Box sx={{ marginTop: "24px" }}>
        <Typography
          variant="subtitle1"
          component="div"
          sx={{
            fontSize: "16px",
            lineHeight: "24px",
            fontWeight: "600",
          }}
        >
          Caterpillar 988f wheel loaders/integrated tools carriers 70 Characters
        </Typography>
        <Box sx={{ display: "flex", columnGap: "16px", marginTop: "24px" }}>
          <Box sx={{ width: "156px" }}>
            <Typography
              variant="body2"
              color="#616161"
              sx={{ fontSize: "14px", lineHeight: "20px" }}
            >
              Year
            </Typography>
            <Typography
              variant="body2"
              color="#616161"
              sx={{ fontSize: "14px", lineHeight: "20px" }}
            >
              Hours
            </Typography>
            <Typography
              variant="body2"
              color="#616161"
              sx={{ fontSize: "14px", lineHeight: "20px" }}
            >
              Condition
            </Typography>
          </Box>
          <Box sx={{ width: "156px" }}>
            <Typography
              variant="body2"
              color="text.primary"
              sx={{
                fontWeight: "600",
                fontSize: "14px",
                lineHeight: "20px",
              }}
            >
              2,000
            </Typography>
            <Typography
              variant="body2"
              color="text.primary"
              sx={{
                fontWeight: "600",
                fontSize: "14px",
                lineHeight: "20px",
              }}
            >
              295,000
            </Typography>
            <Typography
              variant="body2"
              color="text.primary"
              sx={{
                fontSize: "14px",
                fontWeight: "600",
                lineHeight: "20px",
              }}
            >
              Used
            </Typography>
          </Box>
        </Box>
        <Divider sx={{ marginY: "16px" }} />
        <Box sx={{ display: "flex", columnGap: "16px", marginTop: "24px" }}>
          <Box sx={{ width: "156px" }}>
            <Typography
              variant="body2"
              color="#616161"
              sx={{ fontSize: "14px", lineHeight: "20px" }}
            >
              Advertised Price
            </Typography>
            <Typography
              variant="body2"
              color="#616161"
              sx={{ fontSize: "14px", lineHeight: "20px" }}
            >
              Your offer
            </Typography>
          </Box>
          <Box sx={{ width: "156px" }}>
            <Typography
              variant="body2"
              color="text.primary"
              sx={{
                fontWeight: "600",
                fontSize: "14px",
                lineHeight: "20px",
              }}
            >
              USD 48,502
            </Typography>
            <Typography
              variant="body2"
              color="text.primary"
              sx={{
                fontSize: "14px",
                fontWeight: "600",
                lineHeight: "20px",
              }}
            >
              USD 50,000
            </Typography>
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

export default ProductPage;
